import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import firebase from "firebase/app";
import "firebase/firestore";
import { Card } from "react-bootstrap";
import FalconCardHeader from "components/common/FalconCardHeader";
import Flex from "components/common/Flex";

// Mapping des nationalités
const nationalityMapping = {
  "FRANÇAISE": "FRANÇAISE",
  "FRANCAISE": "FRANÇAISE",
  "FRANÇAIS": "FRANÇAISE",
  "FRANCE": "FRANÇAISE",
  "FRANCAIS": "FRANÇAISE",
  "ANGLAISE": "ANGLAISE",
  "ANGLAIS": "ANGLAISE",
  "BRITANIQUE": "ANGLAISE",
  "BRITANNIQUE": "ANGLAISE",
  "BRITISH": "ANGLAISE",
  "BRITSIH": "ANGLAISE",
  "ROYAUME-UNI": "ANGLAISE",
  "UK": "ANGLAISE",
  "AMÉRICAINE": "AMÉRICAINE",
  "AMÉRICAIN": "AMÉRICAINE",
  "AMERICAIN": "AMÉRICAINE",
  "USA": "AMÉRICAINE",
  "DANOISE": "DANOISE",
  "DANOIS": "DANOISE",
  "EMIRATIS": "EMIRATS ARABE UNIS",
  "EMIRATIE": "EMIRATS ARABE UNIS",
  "EMIRATS ARABE UNIS": "EMIRATS ARABE UNIS",
  "MONACO": "MONEGASQUE",
  "MONEGASQUE": "MONEGASQUE",
  "ITALIE": "ITALIE",
  "ITALIENNE": "ITALIE",
  "ESPAGNE": "ESPAGNOLE",
  "ESPAGNOLE": "ESPAGNOLE",
  "SUD-AFRICAINE": "SUD-AFRICAINE",
  "AFRIQUE DU SUD": "SUD-AFRICAINE",
};

const NationalityStats = ({crm, annee}) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchNationalities = async () => {
      const nationalityCount = {};

      crm.forEach((doc) => {
        let nationality = doc.nationality?.trim().toUpperCase();
        if (nationality) {
          nationality = nationalityMapping[nationality] || nationality; // Appliquer le mapping
          nationalityCount[nationality] = (nationalityCount[nationality] || 0) + 1;
        }
      });

      const data = Object.entries(nationalityCount).map(([name, value]) => ({
        name,
        value,
      }));

      setChartData(data);
    };

    fetchNationalities();
  }, []);

  const options = {
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c} ({d}%)",
    },
    series: [
      {
        type: "pie",
        radius: "50%",
        data: chartData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return (
    <Card className="h-100">
      <FalconCardHeader title={'Nationalité / Clients en '+annee} titleTag="h6" className="py-2" light />
      <Card.Body className="h-100">
        <ReactECharts option={options} style={{ height: 400, width: "100%" }} />
        <p>{crm.length} clients pour {annee}</p>
      </Card.Body>
    </Card>
  );
};

export default NationalityStats;